import { render, staticRenderFns } from "./sidebarContent.vue?vue&type=template&id=86c82b30&"
import script from "./sidebarContent.vue?vue&type=script&lang=js&"
export * from "./sidebarContent.vue?vue&type=script&lang=js&"
import style0 from "./sidebarContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports